module.exports = __webpack_public_path__ + "b0ca8dd5fce00f4d6700a13c68c79bb3.jpg";